import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import 'react-tippy/dist/tippy.css';

ReactDOM.render(<App />, document.getElementById('root'));
